/* unplugin-vue-components disabled */import { render } from "./dsmap.vue?vue&type=template&id=b4c1fb4e&scoped=true"
import script from "./dsmap.vue?vue&type=script&lang=js"
export * from "./dsmap.vue?vue&type=script&lang=js"

import "./dsmap.vue?vue&type=style&index=0&id=b4c1fb4e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4c1fb4e"]])

export default __exports__